import { Directive, OnInit, OnDestroy, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';

@Directive({
	selector: '[copoInputNumber]',
})
export class InputNumberDirective implements OnInit, OnDestroy {
	@Input()formControl!: FormControl;
	@Input()min?: number;
	@Input()max?: number;
	@Input()decimalCount?: number;

	val = '';
	private lastAcceptedValue: number | undefined;
	private sub?: Subscription;

	ngOnInit() {
		this.checkInputValue(<number | undefined> this.formControl.value);
		this.sub = this.formControl.valueChanges.subscribe(newValue => {
			this.checkInputValue(newValue);
		});
	}

	checkInputValue(newValue: unknown) {
		switch (newValue) {
		case null:
		case undefined:
		case '':
			this.lastAcceptedValue = undefined;
			this.formControl.setValue(this.lastAcceptedValue, { emitEvent: false });
			return;
		}

		const value = Number(newValue);
		if (Number.isNaN(value)) {
			this.formControl.setValue(this.lastAcceptedValue, { emitEvent: false });
			return;
		}

		if (this.min !== undefined && value < this.min) {
			this.formControl.setValue(this.lastAcceptedValue, { emitEvent: false });
			return;
		}
		if (this.max !== undefined && value > this.max) {
			this.formControl.setValue(this.lastAcceptedValue, { emitEvent: false });
			return;
		}
		if (this.decimalCount === undefined) {
			this.lastAcceptedValue = value;
			return;
		}
		if (Number(value.toFixed(this.decimalCount)) !== value) {
			this.formControl.setValue(this.lastAcceptedValue, { emitEvent: false });
			return;
		}
		this.lastAcceptedValue = value;
	}

	ngOnDestroy() {
		if (this.sub) {
			this.sub.unsubscribe();
		}
	}
}
